module.exports = __webpack_public_path__ + "static/media/whisky_thumb_1.e81be25f.jpg";